<template>
  <help-dialog title="Project Dashboard" content-class="dialog-top-right">
    <template #activator="{ openDialog }">
      <v-btn
        variant="text"
        icon="mds:help"
        class="mr-4"
        @click="openDialog"
      />
    </template>

    <template #default>
      <h3 class="mb-1 text-black">Welcome to Your Project Dashboard!</h3>
      <p class="text-grey-darken-3">
        Here, you can manage all workflows and team members for this project.
        The currently selected project is displayed at the top of the screen, next to the organisation name and the Home icon <v-icon size="small">mds:home</v-icon>.
        <br><br>
        To return to the Home Dashboard, click the Home icon <v-icon size="small">mds:home</v-icon> in the top-left corner.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">Starred Workflows</h3>
      <p class="text-grey-darken-3">
        At the top, you’ll see any workflows you’ve starred for quick access (if you have any).
        To star or unstar a workflow, hover over its thumbnail and use the menu that appears.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">Other / All Workflows</h3>
      <p class="text-grey-darken-3">
        Below the starred section (if any workflows are starred), you’ll find all other workflows associated with this project.
        Click any workflow to open it. To create a new workflow, click <b>+ New Workflow</b>.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">Project Members</h3>
      <p class="text-grey-darken-3">
        Below the workflows, you can view all members of this project. Use the <b>Invite Members</b> button to invite new members.
        <br><br>
        Team members <b>CAN</b>:
      </p>
      <ul class="ml-4">
        <li>Access and edit all workflows in the project.</li>
        <li>Add and delete workflows.</li>
        <li>Invite and remove other team members (except the owner).</li>
      </ul>
      <br>
      <p class="text-grey-darken-3">
        Team member <b>CANNOT</b>:
      </p>
      <ul class="ml-4">
        <li>Delete the project or change the owner.</li>
        <li>Unlock a workflow if it is locked for changes (i.e., its status is set to Completed under Settings). Only the owner can unlock a workflow. A locked workflow also cannot be deleted.</li>
      </ul>
      <br><br>
      <h3 class="mb-1 text-black">Quick Tips</h3>
      <ul class="ml-4">
        <li><b>Edit/Copy Workflows:</b> Hover over any workflow to display its context menu. From there, you can copy, edit, or delete the workflow.</li>
        <li><b>Star Workflows:</b> Keep your most important workflows at the top of the page by starring them for faster access.</li>
        <li><b>Invite Members:</b> Easily collaborate by inviting team members directly to the project.</li>
        <li><b>Remove Members:</b> You can remove team members from the project using the actions menu in the member list. If you want to leave the project, you can also remove yourself—unless you are the project owner.</li>
      </ul>
      <br>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>
